module.exports = __webpack_public_path__ + "static/media/urban-about-us.1f014e8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/icons/urban-about-us.svg
// module id = 660
// module chunks = 0